<template>
    <card>
        <template slot="header">
            <h4 class="card-title">{{ $t("dashboard.repairscomplete_title") }}</h4>
            <p class="card-category text-muted">{{ $t("dashboard.repairscomplete_subtitle") }}</p>
            <select @change="setPeriod">
              <option v-for="date in dates" :value="date.year + '/' + date.month">{{ date.label }}</option>
            </select>
        </template>
        <br />
        <div class="container py-4">
            <bar v-if="loaded" :chartdata="chartdata" :options="options" style="height: 270px"></bar>
        </div>

        <div class="mt-2 h6" v-if="loaded">
            <slot v-for="(label, index) in chartdata.labels">
                <small class="mr-2 d-inline-block" :key="index">
                    <i class="fas fa-circle" :style="'color:'+colors.fill[index]"></i>
                    {{ label }}
                </small>
            </slot>
        </div>
    </card>
</template>

<script>
import { Bar } from "@/components/index";
import $http from "@/helpers/api";
import { generateColors } from "@/helpers/filters";
export default {
  name: "ReparisPerMonthByASF",
  components: { Bar },
  computed: {
    now() {
      return new Date();
    }
  },
  data: () => ({
    loaded: false,
    dates: [],
    month: 0,
    year: 0,
    colors: [],
    chartdata: {
      labels: [],
      datasets: []
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      legend: {
        display: false
      },
      scales: {
        xAxes: [
          {
            display: false
          }
        ],

        // And this will affect the horizontal lines (yAxe) of your dataset
        yAxes: [
          {
            ticks: {
                min: 0,
                stepSize: 1
            },
            gridLines: {
              drawBorder: false,
              borderDash: [3, 3]
            }
          }
        ]
      }
    }
  }),
  methods: {
    setPeriod(e) {
      e.target.value;
      // console.log(e.target.value);
      [this.year, this.month] = e.target.value.split("/");
      // console.log(this.year);
      // console.log(this.month);
      this.getData();
    },
    getData() {
      this.loaded = false;
      let url = "/graph/repairsperasf/" + this.year + "/" + this.month;
      $http.get(url).then(resp => {
        this.colors = {
          fill: generateColors(resp.data.data.length, "B3"),
          border: generateColors(resp.data.data.length)
        };
        this.chartdata = {
          labels: resp.data.label,
          datasets: [
            {
              label: "Total",
              data: resp.data.data,
              backgroundColor: this.colors.fill,
              borderColor: this.colors.border,
              borderWidth: "1",
              hoverBackgroundColor: this.colors.border
            }
          ]
        };
        this.loaded = true;
        // console.log(this.chartdata.labels);
      });
    },
    getMonthsYears() {
      $http.get("/graph/monthsyears").then(resp => {
        this.dates = resp.data;
      });
    }
  },
  watch: {
    data: function (){
      this._chart.destroy();
      console.log(this.data);
      console.log(this.options);
      //this.renderChart(this.data, this.options);
      // this.renderLineChart();
    }    
  },
  console: () => console,
  mounted() {
    this.month = this.now.getMonth() + 1;
    this.year = this.now.getFullYear();
    this.getData();
    this.getMonthsYears();
  }
};
</script>
